// extracted by css-extract-rspack-plugin
export default {"cls1":"Tabs-cls1_gKy","cls2":"Tabs-cls2_dLi Tabs-cls1_gKy","active":"Tabs-active_xTp"};